module.exports = __webpack_public_path__ + "img/2019_b_s_s.81b485df.jpg";